module.exports = __webpack_public_path__ + "img/rocket_tank_factory_small.bcb0235b.png";